// const baseurl='http://192.168.0.33:6702/'
// const baseurl='https://esusong.cdelink.cn:16704/'
const baseurl='https://www.jpito.com/api'
export default baseurl